var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    fill: "#888",
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3375 10.5736L19.9789 3.35133C20.0974 2.82987 19.7011 2.33331 19.1663 2.33331H5.52806L5.20979 0.777404C5.13049 0.389591 4.78924 0.111084 4.39337 0.111084H0.833334C0.37309 0.111084 0 0.484174 0 0.944417V1.49997C0 1.96022 0.37309 2.33331 0.833334 2.33331H3.25983L5.69899 14.2581C5.11545 14.5937 4.72222 15.223 4.72222 15.9444C4.72222 17.0183 5.59278 17.8889 6.66667 17.8889C7.74056 17.8889 8.61111 17.0183 8.61111 15.9444C8.61111 15.4002 8.38726 14.9085 8.02695 14.5555H15.3064C14.9461 14.9085 14.7222 15.4002 14.7222 15.9444C14.7222 17.0183 15.5928 17.8889 16.6667 17.8889C17.7406 17.8889 18.6111 17.0183 18.6111 15.9444C18.6111 15.1746 18.1636 14.5093 17.5146 14.1942L17.7062 13.3513C17.8247 12.8299 17.4283 12.3333 16.8936 12.3333H7.57351L7.34625 11.2222H17.5249C17.914 11.2222 18.2513 10.953 18.3375 10.5736Z M 7 8.9 L 15.9 8.9 L 16.7 4.7 L 6.1 4.7 z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.019f22fef693aba141beba27aa5b0ade.svg";
export { ForwardRef as ReactComponent };